import createCardListingView from '../Views/createCardListingView';
import FlexNewsCard from './FlexNewsCard';

// News is a fixed responsive grid of its own, so the generic Grid layout
// setting doesn't apply. The link to the full view was hardcoded off here
// while every other listing had it as a setting; it is a setting now too,
// still off unless a block turns it on, so existing blocks are unchanged.
export default createCardListingView(FlexNewsCard, {
  displayName: 'NewsListingView',
  containerClass: 'cards__container--news',
  supportsGrid: false,
  hideLinkByDefault: true,
});
